import { appQueryClient } from '../../../../provider'
import type { RestCounterType } from '../../types/RestCounter'

import type {
  FetchAccumulatorsUserContractQueryParams,
  FetchMultiTypeAccumulatorsUserContractQueryParams
} from './accumulators.contract.api'

export const accumulatorsUserContractCachekeys = {
  multiTypeAccumulators: (
    user_contract_id: number,
    queryParams?: FetchMultiTypeAccumulatorsUserContractQueryParams
  ) => ['accumulators_user_contract', user_contract_id, queryParams],
  restTypeAccumulators: (
    user_contract_id: number,
    type: RestCounterType,
    queryParams?: FetchAccumulatorsUserContractQueryParams
  ) => ['accumulators_user_contract', user_contract_id, type, queryParams]
}

export const accumulatorUserContractInvalidations = {
  invalidateUserContract: (
    user_contract_id: number,
    type: RestCounterType,
    queryParams: FetchAccumulatorsUserContractQueryParams
  ) => {
    appQueryClient.invalidateQueries({
      queryKey: accumulatorsUserContractCachekeys.restTypeAccumulators(
        user_contract_id,
        type,
        queryParams
      )
    })
  }
}
